import { z } from "zod";

export const vehicleTypeSchema = z.enum(["PERSONAL", "SHARED", "OUT_OF_FLEET"]);

export const vehicleTypes = vehicleTypeSchema.options;
export type VehicleType = z.infer<typeof vehicleTypeSchema>;
